import { defaultTo } from 'lodash';
import { selectActivePackage, selectActivePlacingType } from '../../../../selectors/publishTerms';
import { IAppState } from '../../../../../AppModulesWrapper';
import { selectPaidPublication } from '../../paidPublication/selectors';
import { EPlacingType } from '../../../../types/reducers/publishTerms';

export const selectDefaultRecommendedPackagePublicationPrice = (state: IAppState): number => {
  const activePlacingType = selectActivePlacingType(state);
  const { price: publicationPrice, isPaid } = selectPaidPublication(state);
  const activePackage = selectActivePackage(state);

  const { price: packagePrice = 0 } = activePackage || {};

  if (activePlacingType === EPlacingType.package) {
    return packagePrice;
  }

  // Объявление редактируется и пользователь платил деньги за публикацию (в некоторых регионах публикация бесплатна)
  const isFreePublicationPrice = isPaid && publicationPrice;

  return isFreePublicationPrice ? 0 : defaultTo(publicationPrice, 0);
};
